import Swal from 'sweetalert2'
import './styles.css'
import withReactContent from 'sweetalert2-react-content'

import React, { useEffect, useState } from "react";
import {
  Button,
  Header,
  Icon,
  Modal,
  Step,
  Loader,
  Dimmer,
} from "semantic-ui-react";
import { post } from "../../../../../../../services/request";
import {
  HireProposalModalProps,
  PottencialModalHireProposalProps,
} from "../../../types/ModalHireProposalProps";
import { SurtyPottencialInsuranceFormik } from "../Formik/SurtyFormFormik";
import {
  dangerNotification,
  successNotification,
} from "../../../../../../../services/notification";
import { hasPermission } from '../../../../../../../components/AuthorizationContainer';
import { ActionEnum } from '../../../../../../../enums/authz-action.enum';
import { FeatureEnum } from '../../../../../../../enums/authz-feature.enum';
import { extractApiErrorMessages } from '../../../../../../../utils/apiErrorHandler';

const HireProposalPottencialModal = ({
  analysis,
  bondInsurance,
  closeModal,
  callback,
}: PottencialModalHireProposalProps) => {
  const [openHireProposalModal, setOpenHireProposalModal] = useState(false);
  const [flagSubmitFrom, setFlagSubmitFrom] = useState(false);
  const [stepOfHireModal, setStepOfHireModal] = useState(
    "pottencialProposal"
  );
  const [loading, setLoading] = useState(false);

  const [userCanContract, setUserCanContract] = useState(false);

  useEffect(() => {
    const has = hasPermission(ActionEnum.contract, FeatureEnum.analysis);
    setUserCanContract(has);
  }, []);

  const MySwal = withReactContent(Swal)

  async function handleSubmit(payload: any){
    try {
      setLoading(true)
      await post("/bond-insurance/proposals/hire/pottencial", payload);
      successNotification("Sucesso", "Registro concluido com sucesso.");
      callback();
      closeModal();
      setOpenHireProposalModal(false);
    } catch (err) {
      dangerNotification("Erro", extractApiErrorMessages(err, 'Erro ao efetuar solicitação.'), 10000);
      console.log(err);
    } finally {
      setLoading(false);
      setFlagSubmitFrom(false);
    }
  }

  const AcceptTerms = () =>
  MySwal.fire({
    title: `Deseja prosseguir com a contratação em <b>${analysis.insurer?.name}</b> ?`,
    text: "Importante: A cláusula deverá ser inserida no Contrato de Locação e os dados informados para essa contratação deverão estar inseridos e de acordo com o Contrato de Locação.",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Sim, prosseguir para a contratação!',
    cancelButtonText: 'Cancelar'
  }).then((result) => {
    if (result.isConfirmed) {
      (async () => {
        const { value: checked } = await MySwal.fire({
          title: 'Declaro que: ',
          html:
            '<div class="row"><input id="swal-input1" type="checkbox" class="checkbox"> <label for="swal-input1">Os dados informados para essa contratação estão de acordo e inseridos no Contrato de Locação; Qualquer alteração realizada nesta etapa, poderá afetar o orçamento realizado.</label> </div>' +
            '<div class="row"><input id="swal-input2" type="checkbox" class="checkbox"> <label for="swal-input2">A Cláusula foi inserida no Contrato de Locação. </label> </div>' +
            '<div class="row"><input id="swal-input3" type="checkbox" class="checkbox"> <label for="swal-input3"> Declaro que essa locação não tem débitos em aberto até esta data. </label> </div>',
          focusConfirm: false,
          confirmButtonText:
            'Ciente e prosseguir',
          denyButtonText: 'Cancelar',
          preConfirm: () => {
            return [
              (document.getElementById('swal-input1') as HTMLInputElement).checked ? 'true' : 'false',
              (document.getElementById('swal-input2') as HTMLInputElement)?.checked ? 'true' : 'false',
              (document.getElementById('swal-input3') as HTMLInputElement)?.checked ? 'true' : 'false',
            ]
          },
        })
        console.log(checked)
        if (Array.isArray(checked) && checked[0] === 'true' && checked[1] === 'true' && checked[2] === 'true') {
          setOpenHireProposalModal(true)
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Para continuar, deve aceitar os termos!',
          })
        }
      })()
    }
  })

  return (
    <div style={{ outline: 'none', zIndex: 10, flex: 'auto' }}>
      <Modal
        closeIcon
        open={openHireProposalModal}
        onClose={
          () =>  setOpenHireProposalModal(false)
        }
        trigger={
          <Button
            disabled={!userCanContract}
            positive
            fluid
          >
            Contratar
          </Button>
        }
        onOpen={AcceptTerms}
      >
        <Header icon="file alternate outline" content="Contratação Fiança | Pottencial" />
        <Modal.Content scrolling>
          <Dimmer active={loading}>
            <Loader indeterminate> Enviando proposta... </Loader>
          </Dimmer>
          <Step.Group>
          <Step
                onClick={() => setStepOfHireModal("pottencialProposal")}
                active={stepOfHireModal === "pottencialProposal"}
                title="Cotação Seguro Pottencial"
                description="Preencha os dados faltantes para realizar a cotação e, se for o caso, a contratação"
              />
          </Step.Group>
          {stepOfHireModal === "pottencialProposal" && (
            <SurtyPottencialInsuranceFormik
              maxInstallments={bondInsurance.property.validity}
              nominal_total_premium_amount={analysis.value}
              naturalTentant={bondInsurance.natural_tenant}
              property={bondInsurance.property}
              flagSubmit={flagSubmitFrom}
              callbackSubmit={handleSubmit}
              analysisID={analysis.id}
              setFlagSubmit={setFlagSubmitFrom}
              bondInsurance={bondInsurance}
              approvedAt={analysis.updatedAt}
              offers={analysis.offers}
            />
          )}
        </Modal.Content>
        <Modal.Actions>
          <Button color="red" onClick={() => setOpenHireProposalModal(false)}>
            <Icon name="remove" /> Sair
          </Button>
          <Button color="green" onClick={() => setFlagSubmitFrom(true)}>
            <Icon name="checkmark" />
           Confirmar
          </Button>
        </Modal.Actions>
      </Modal>
    </div>
  );
};
export default HireProposalPottencialModal;
